import { useState } from "react";
import Crown from '@/assets/GHChess5.png';
import { HOME, type HomeState } from "@/shared/constants/home";
import PlayButton from "@/components/shell/PlayButton";
import Locked from "@/components/Locked";

  type Props = {
    setHomeState: (state: HomeState) => void;
    setVariationHelpModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setJoinMatchModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  };

  function HomeScreen({ setHomeState, setVariationHelpModalOpen, setJoinMatchModalOpen }: Props) {


  return (
      <div>
          <div style={{display: "flex", justifyContent: "center"}}>
            <img width={525} height={350} style={{ position: "absolute", top: "-100px", marginRight: "10px"}} src={Crown} alt="logo" />
          </div>
          <div className="chooseTournamentType">
            <PlayButton kind={HOME.FC} text="Upcoming Tournaments" setHomeState={setHomeState} />
            <PlayButton kind={HOME.NP} text="No Prize" setHomeState={setHomeState}/>
          </div>
          <div className="mij">
            <button className="mijButton" onClick={() => setVariationHelpModalOpen(true)}>
                Learn Different Game Variants
            </button> 
            <button disabled={true} className="mijButton" onClick={() => setJoinMatchModalOpen(true)}>
                  Join Private Tournament
                  <Locked home={true} inline />
            </button>
          </div>
        </div>
  )}

export default HomeScreen;
